'use strict';

var alertNotification = require('../components/alertNotification');

/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for contact us sign-up
 */
function displayMessage (data) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    alertNotification.set(
        {
            alertName: 'contact-us-signup',
            alertOptions: {
                message: data.msg,
                status: status
            }
        }
    );
}

class ContactUs {
    subscribeContact () {
        $('form.contact-us').submit(function (e) {
            var form = $(this);
            // var url = form.attr('action');

            $('.g-recaptcha', form).removeClass('is-invalid');
            if (!window.grecaptcha.getResponse()) {
                e.preventDefault();
                $('.g-recaptcha', form).addClass('is-invalid');
                return false;
            }

            // $.spinner().start();
            // $.ajax({
            //     url: url,
            //     type: 'post',
            //     dataType: 'json',
            //     data: form.serialize(),
            //     success: function (data) {
            //         displayMessage(data);
            //         if (data.success) {
            //             $('.contact-us').trigger('reset');
            //         }
            //     },
            //     error: function (err) {
            //         displayMessage(err);
            //     }
            // });
        });
    }

    handleCaseChange () {
        $('.js-contact-topic').change((e) => {
            const isCaseOrder = e.target.value.toLowerCase() === 'order';

            if (isCaseOrder) {
                $('.order-number').removeClass('hidden');
                $('.order-number input').attr('required', 'required').addClass('required');
            } else {
                $('.order-number').addClass('hidden');
                $('.order-number input').removeAttr('required').removeClass('required');
            }
        });
    }

    handleMessageLimit () {
        const MESSAGE_WORDS_LIMIT = $('.js-contact-message').data('parsley-words-limit');

        $('.js-contact-message').on('input', e => {
            const value = e.target.value;
            const text = value.replaceAll(/\s+/g, ' ').trim();
            const words = text ? text.split(' ').length : 0;

            $('.js-contact-message').siblings('.help-block').text(`${words}/${MESSAGE_WORDS_LIMIT}`);
        });
    }

    composePhoneNumber() {
        const form = $('form.contact-us');

        const concat = () => {
            const prefix = $('.js-phone-prefix', form).val();
            const number = $('.js-phone-number', form).val();
            const fullNumber = `${prefix}${number}`;

            $('.js-phone').val(fullNumber).attr('value', fullNumber);
        };

        form.find('.js-phone-prefix, .js-phone-number').on('change input', concat);
    }

    get init () {
        this.handleCaseChange();
        this.handleMessageLimit();
        this.composePhoneNumber();
        this.subscribeContact();
    }
}

const contactUs = new ContactUs;
export default contactUs;
